var map = {
	"./abonentProfile.graphql": "a780",
	"./billingAccounts.graphql": "0af1",
	"./chatBot.graphql": "0af4",
	"./claimedConsumptionB.graphql": "1b72",
	"./consumption.graphql": "a584",
	"./consumptionCounters.graphql": "666c",
	"./consumptionGroupATemplateFile.graphql": "f40b",
	"./consumptionInfo.graphql": "e570",
	"./invoiceFileLast.graphql": "1171",
	"./model.graphql": "1dcc",
	"./payments.graphql": "635a",
	"./requests.graphql": "0a41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f6b";